<template>
    <a-tabs
        animated
        v-model:activeKey="page"
    >
        <a-tab-pane :key="1" tab="전체">
                <survey-2024-all :eventData="eventData" />
        </a-tab-pane>
        <a-tab-pane :key="2" tab="스마일 라식" forceRender>
                <survey-2024-smile :eventData="eventData" :currentTab="page" />
        </a-tab-pane>
        <a-tab-pane :key="3" tab="스마일 프로" forceRender>
                <survey-2024-smile-pro :eventData="eventData" :currentTab="page" />
        </a-tab-pane>
    </a-tabs>
</template>
<script>
import {
  formatCommaNumber,
  oneBtnDialog,
} from "@/utils/utils";
import dayjs from "dayjs";
import 'dayjs/locale/ko'
import locale from "ant-design-vue/es/date-picker/locale/ko_KR";
import Survey2024All from "@/views/EventManagement/components/zeiss/Survey2024All.vue";
import Survey2024Smile from "@/views/EventManagement/components/zeiss/Survey2024Smile.vue";
import Survey2024SmilePro from "@/views/EventManagement/components/zeiss/Survey2024SmilePro.vue";

export default {
    components: {
        Survey2024All,
        Survey2024Smile,
        Survey2024SmilePro,
    },
    computed: {
        noResult() {
            return !this.$store.state.isLoading && this.eventData.totalDocs === 0
        },
        computedNoResultMessage() {
            return this.$i18n.t('noresult_event');
            if(this.calledApiTimes <= 1) {
                return this.$i18n.t('noresult_event_period');
            } else {
                return this.$i18n.t('noresult_event_period');
            }
        },
        combinedData() {
            return this.eventData;
        },
    },
    props: {
        eventData: Object,
    },
    watch: {
        combinedData: {
            handler(newData) {
                if (newData) {
                    if(!newData.eventStats || !newData.summary) return;
                    this.uiHandler.processEventStats(newData);
                }
            },
            immediate: true,
        },
    },
    mounted() {
    },
    data() {
        return {
            uiHandler: this.ui(),
            formatCommaNumber,
            locale,
            dataLoading: false,
            modal: {
                createEvent: {
                    show: false
                },
            },
            calledApiTimes: 0,
            page: 1,
            events: {
                startAt: null,
                endAt: null,
                totalDocs: 0,
                list: [],
                summary: {
                    list: [],
                },
                surveyResults: {},
            },
        }
    },
    methods: {
        dayjs,
        ui() {
            return {
                processEventStats: (data) => {
                    this.events.list = data.eventStats.map(item => {
                        return {
                            ...item.statsData,
                            ...item,
                        }
                    });
                    this.events.summary.list = [data.summary];
                    this.events.surveyResults = data.summary.surveyResults;
                },
                updateItemRatioChartData:() => {
                    if (this.events.summary.list[0]) {
                        const smileCount = this.events.summary.list[0]?.smileCount || 0;
                        const smileProCount = this.events.summary.list[0]?.smileProCount || 0;
                        this.charts.itemRatioChart.data.datasets[0].data = [smileCount, smileProCount];
                        this.charts.itemRatioChart.options.plugins = {
                            tooltip: {
                                callbacks: {
                                    label: (context) => {
                                        const label = context.label || '';
                                        const value = context.raw; // 원래 값
                                        const total = this.events.summary.list[0]?.smileCount + this.events.summary.list[0]?.smileProCount || 0;
                                        const percentage = total > 0 ? Math.round((value / total) * 100) + '%' : '0%';
                                        return `${label}: ${value.toLocaleString()}명 (${percentage})`;
                                    }
                                }
                            },
                            datalabels: {
                                display: true,
                                color: 'white', // 글씨 색상 하얀색
                                formatter: (value) => {
                                    const total = this.events.summary.list[0]?.smileCount + this.events.summary.list[0]?.smileProCount || 0;
                                    const percentage = total > 0 ? Math.round((value / total) * 100).toFixed(1) + '%' : '0%';
                                    return percentage;
                                }
                            },
                            legend: {
                                onClick: null,
                                display: true,
                                position: 'right',
                                align: 'start',
                                // labels: {
                                //     boxWidth: 15,
                                //     padding: 15,
                                //     textAlign: 'right',
                                //     generateLabels: (chart) => {
                                //         return [
                                //             { text: '가장 많음', fillStyle: '#F55247' },
                                //             { text: '가장 적음', fillStyle: '#278AEC' },
                                //         ];
                                //     }
                                // }
                            },
                        }
                        // 차트 리렌더링을 위한 키 업데이트
                        this.charts.itemRatioChart.chartKey += 1;
                    }
                },
                updateHourlyChartData:() => {
                    if (this.events.summary.list[0] && this.events.summary.list[0].hourlyStats) {
                        const hourlyStats = this.events.summary.list[0].hourlyStats;

                        const groupedStats = hourlyStats.reduce((acc, stat) => {
                            if (stat.hour >= 0 && stat.hour <= 7) {
                                // 0~7시의 경우
                                if (!acc[0]) {
                                    acc[0] = { hour: '0~7', count: 0, percentage: '0%' };
                                }
                                acc[0].count += stat.count;
                            } else {
                                // 8시 이후의 경우
                                acc.push(stat);
                            }
                            return acc;
                        }, []);
                        
                        const counts = hourlyStats.map(stat => stat.count);
                        const minCount = Math.min(...counts);
                        const maxCount = Math.max(...counts);

                        this.charts.hourlyChart.data = {
                            labels: groupedStats.map(stat => `${stat.hour}시`),
                            datasets: [{
                                label: '시간별 응답 수',
                                data: counts,
                                backgroundColor: counts.map(count => {
                                    if (count === minCount) return '#278AEC';
                                    if (count === maxCount) return '#F55247';
                                    return '#ACB2B9'; // 평균 (청록색)
                                }),
                                barThickness: 15,
                            }]
                        };

                        this.charts.hourlyChart.options = {
                            responsive: true,
                            maintainAspectRatio: false,
                            scales: {
                                x: {
                                    title: {
                                        display: true,
                                        text: '응답 시간대'
                                    }
                                },
                                y: {
                                    beginAtZero: true,
                                    title: {
                                        display: true,
                                        text: '응답 수'
                                    },
                                    ticks: {
                                        display: true,
                                        callback: function(value) {
                                            if (value % 1 === 0) {
                                                return value.toLocaleString();
                                            }
                                        }
                                    }
                                },

                            },
                            plugins: {
                                tooltip: {
                                    callbacks: {
                                        label: (context) => {
                                            const label = context.dataset.label || '';
                                            const value = context.parsed.y;
                                            const percentage = this.events.summary.list[0].hourlyStats[context.dataIndex].percentage;
                                            return `${label}: ${value.toLocaleString()}명 (${percentage})`;
                                        }
                                    }
                                },
                                legend: {
                                    display: true,
                                    onClick: null,
                                    position: 'right',
                                    align: 'start',
                                    labels: {
                                        boxWidth: 15,
                                        padding: 15,
                                        textAlign: 'right',
                                        generateLabels: (chart) => {
                                            return [
                                                { text: '가장 많음', fillStyle: '#F55247' },
                                                { text: '가장 적음', fillStyle: '#278AEC' },
                                            ];
                                        }
                                    }
                                },
                                datalabels: {
                                    display: false
                                }
                            }
                        };
                        // 차트 리렌더링을 위한 키 업데이트
                        this.charts.hourlyChart.chartKey += 1;
                    }
                },
                updateGenderChartData:() => {
                    if (this.events.summary.list[0] && this.events.summary.list[0].genderStats) {
                        const genderStats = this.events.summary.list[0].genderStats;
                        this.charts.genderChart.data = {
                            labels: ['남성', '여성', '알 수 없음'],
                            datasets: [{
                                label: '성별 응답 수',
                                data: [genderStats.male, genderStats.female, genderStats.unknown],
                                backgroundColor: ['#278AEC', '#F55247', '#ACB2B9'], // 각 성별에 대한 색상
                                barThickness: 15,
                            }]
                        };
                        const total = genderStats['total'];

                        const malePercentage = total > 0 ? ((genderStats.male / total) * 100).toFixed(1) : 0;
                        const femalePercentage = total > 0 ? ((genderStats.female / total) * 100).toFixed(1) : 0;
                        console.log(malePercentage)
                        console.log(femalePercentage)
                        this.displayValues.maleRatio = malePercentage;
                        this.displayValues.femaleRatio = femalePercentage;

                        
                        this.charts.genderChart.options = {
                            responsive: true,
                            maintainAspectRatio: false,
                            plugins: {
                                tooltip: {
                                    callbacks: {
                                        label: (context) => {
                                            const label = context.label || '';
                                            const value = context.parsed;
                                            const percentage = ((value / total) * 100).toFixed(1);
                                            return `${label}: ${value.toLocaleString()}명 (${percentage}%)`;
                                        }
                                    }
                                },
                                legend: {
                                    display: true,
                                    onClick: null,
                                    position: 'bottom',
                                    align: 'start',
                                    labels: {
                                        boxWidth: 15,
                                        padding: 15,
                                        textAlign: 'right',
                                        generateLabels: (chart) => {
                                            return [
                                                { text: '남성', fillStyle: '#278AEC' },
                                                { text: '여성', fillStyle: '#F55247' },
                                                { text: '알 수 없음', fillStyle: '#ACB2B9' }
                                            ];
                                        }
                                    }
                                },
                                datalabels: {
                                    display: true,
                                    color: 'white', // 글씨 색상 하얀색
                                    formatter: (value) => {
                                        return `${(value / total * 100).toFixed(1)}%`;
                                        // const total = this.events.summary.list[0]?.smileCount + this.events.summary.list[0]?.smileProCount || 0;
                                        // const percentage = total > 0 ? Math.round((value / total) * 100) + '%' : '0%';                                    return percentage;
                                    }
                                },
                                // datalabels: {
                                //     display: false
                                // }
                            }
                        };
                        // 차트 리렌더링을 위한 키 업데이트
                        this.charts.genderChart.chartKey += 1;
                    }
                },
                updateAgeChartData:() => {
                    if (this.events.summary.list[0] && this.events.summary.list[0].ageGroupStats) {
                        const ageGroupStats = this.events.summary.list[0].ageGroupStats;
                        const ageLabels = Object.keys(ageGroupStats); // 연령대 라벨
                        const ageData = Object.values(ageGroupStats); // 연령대 데이터
                        const total = ageData.reduce((sum, value) => sum + value, 0);

                        const backgroundColors = ['#278AEC', '#F55247', '#FFCE56', '#4CAF50', '#FF6384', '#ACB2B9'];

                        const maxAgeIndex = ageData.indexOf(Math.max(...ageData));
                        const maxAgeLabel = ageLabels[maxAgeIndex];
                        const maxAgeValue = ageData[maxAgeIndex];
                        this.displayValues.topAgeLabel = maxAgeLabel;
                        this.displayValues.topAgeValue = maxAgeValue;
                        this.charts.ageChart.data = {
                            labels: ageLabels,
                            datasets: [{
                                label: '연령대별 응답 수',
                                data: ageData,
                                backgroundColor: backgroundColors.slice(0, ageData.length), 
                                barThickness: 15,
                            }]
                        };

                        this.charts.ageChart.options = {
                            responsive: true,
                            maintainAspectRatio: false,
                            plugins: {
                                tooltip: {
                                    callbacks: {
                                        label: (context) => {
                                            const label = context.label || '';
                                            const value = context.parsed;
                                            const percentage = ((value / total) * 100).toFixed(1);
                                            return `${label}: ${value.toLocaleString()}명 (${percentage}%)`;
                                        }
                                    }
                                },
                                legend: {
                                    display: true,
                                    onClick: null,
                                    position: 'bottom',
                                    align: 'start',
                                    labels: {
                                        boxWidth: 15,
                                        padding: 15,
                                        textAlign: 'right',
                                        generateLabels: (chart) => {
                                            return ageLabels.map((label, index) => ({
                                                text: label,
                                                fillStyle: backgroundColors[index],
                                                hidden: false,
                                                index: index,
                                            }));
                                        }
                                    }
                                },
                                datalabels: {
                                    display: true,
                                    color: 'white', // 글씨 색상 하얀색
                                    formatter: (value) => {
                                        return `${(value / total * 100).toFixed(1)}%`;
                                        // const total = this.events.summary.list[0]?.smileCount + this.events.summary.list[0]?.smileProCount || 0;
                                        // const percentage = total > 0 ? Math.round((value / total) * 100) + '%' : '0%';                                    return percentage;
                                    }
                                },
                                // datalabels: {
                                //     display: false
                                // }
                            }
                        };
                        // 차트 리렌더링을 위한 키 업데이트
                        this.charts.ageChart.chartKey += 1;
                    }
                },
                updateRecoveryChartData:() => {
                    if (this.events.summary.list[0] && this.events.summary.list[0].recoveryStats) {
                        const recoveryStats = this.events.summary.list[0].recoveryStats;

                        // 라벨과 데이터 배열 생성
                        const labels = Object.keys(recoveryStats); // ["1개월 이내", "1-3개월 이후", "3-6개월 이후", "6개월 이상", "미상"]
                        const data = Object.values(recoveryStats); // [9, 9, 6, 5, 0]
                        const totalResponses = data.reduce((sum, value) => sum + value, 0);
                        const responseCount = Object.keys(recoveryStats).length;

                        let maxResponseCount = 0;
                        let maxResponseLabel = '';
                        for (const [key, value] of Object.entries(recoveryStats)) {
                            if (value > maxResponseCount) {
                                maxResponseCount = value;
                                maxResponseLabel = key;
                            }
                        }

                        // displayValues에 값 설정
                        this.displayValues.afterSurgery.afterSurgeryResponseMostLabel = maxResponseLabel;


                        this.charts.recoveryChart.data = {
                            labels: labels,
                            datasets: [{
                                label: '수술 경과 기간별 응답 수',
                                data: data,
                                backgroundColor: [
                                    '#FF6384', // 1개월 이내
                                    '#36A2EB', // 1-3개월 이후
                                    '#FFCE56', // 3-6개월 이후
                                    '#4CAF50', // 6개월 이상
                                    '#ACB2B9'  // 미상
                                ],
                            }]
                        };

                        this.charts.recoveryChart.options = {
                            responsive: true,
                            maintainAspectRatio: false,
                            plugins: {
                                tooltip: {
                                    callbacks: {
                                        label: (context) => {
                                            const label = context.label || '';
                                            const value = context.raw; // 원래 값
                                            return `${label}: ${value}명`;
                                        }
                                    }
                                },
                                datalabels: {
                                    display: true,
                                    color: 'white', // 글씨 색상 하얀색
                                    formatter: (value) => {
                                        const percentage = totalResponses > 0 ? ((value / totalResponses) * 100).toFixed(1) + '%' : '0%'; // 퍼센트 계산
                                        return percentage; 
                                    }
                                },
                                legend: {
                                    display: true,
                                    position: 'top',
                                }
                            }
                        };

                        // 차트 리렌더링을 위한 키 업데이트
                        this.charts.recoveryChart.chartKey += 1;
                    }
                },
                updateQ1ChartData:() => {
                    if (this.events.summary.list[0] && this.events.summary.list[0].genderStats) {
                        const genderStats = this.events.summary.list[0].genderStats;
                        this.charts.genderChart.data = {
                            labels: ['남성', '여성', '알 수 없음'],
                            datasets: [{
                                label: '성별 응답 수',
                                data: [genderStats.male, genderStats.female, genderStats.unknown],
                                backgroundColor: ['#278AEC', '#F55247', '#ACB2B9'], // 각 성별에 대한 색상
                                barThickness: 15,
                            }]
                        };
                        const total = genderStats['total'];

                        const malePercentage = total > 0 ? ((genderStats.male / total) * 100).toFixed(1) : 0;
                        const femalePercentage = total > 0 ? ((genderStats.female / total) * 100).toFixed(1) : 0;
                        console.log(malePercentage)
                        console.log(femalePercentage)
                        this.displayValues.maleRatio = malePercentage;
                        this.displayValues.femaleRatio = femalePercentage;

                        
                        this.charts.genderChart.options = {
                            responsive: true,
                            maintainAspectRatio: false,
                            plugins: {
                                tooltip: {
                                    callbacks: {
                                        label: (context) => {
                                            const label = context.label || '';
                                            const value = context.parsed;
                                            const percentage = ((value / total) * 100).toFixed(1);
                                            return `${label}: ${value.toLocaleString()}명 (${percentage}%)`;
                                        }
                                    }
                                },
                                legend: {
                                    display: true,
                                    onClick: null,
                                    position: 'bottom',
                                    align: 'start',
                                    labels: {
                                        boxWidth: 15,
                                        padding: 15,
                                        textAlign: 'right',
                                        generateLabels: (chart) => {
                                            return [
                                                { text: '남성', fillStyle: '#278AEC' },
                                                { text: '여성', fillStyle: '#F55247' },
                                                { text: '알 수 없음', fillStyle: '#ACB2B9' }
                                            ];
                                        }
                                    }
                                },
                                datalabels: {
                                    display: true,
                                    color: 'white', // 글씨 색상 하얀색
                                    formatter: (value) => {
                                        return `${(value / total * 100).toFixed(1)}%`;
                                        // const total = this.events.summary.list[0]?.smileCount + this.events.summary.list[0]?.smileProCount || 0;
                                        // const percentage = total > 0 ? Math.round((value / total) * 100) + '%' : '0%';                                    return percentage;
                                    }
                                },
                                // datalabels: {
                                //     display: false
                                // }
                            }
                        };
                        // 차트 리렌더링을 위한 키 업데이트
                        this.charts.genderChart.chartKey += 1;
                    }
                },
                search: async () => {
                    // if(dayjs(this.events.startAt) !== dayjs(this.dateRanges[0])) {
                    //     this.isAllPeriodChecked = false;
                    // }
                    // if(dayjs(this.events.endAt) !== dayjs(this.dateRanges[0])) {
                    //     this.isAllPeriodChecked = false;
                    // }
                },
                convertMonthAndYearText: (input) => {
                    if (input < 12) return `${input}${this.$i18n.t('common_searchfilter_month')}`;
                    return `${input / 12}${this.$i18n.t('common_searchfilter_year')}`;
                },
            }
        },
        api() {
            return eventApis(this.$apiInstance, this.$store);
        }
    }
}
</script>
<style lang="scss">
  @import '@/views/EventManagement/event.scss';
</style>